import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

	html {
		height: -webkit-fill-available;
		min-height: 100%;
		height: 100%;	
		font-family: 'Poppins', sans-serif;
		color: ${p => p.theme.colors.neutralDarkest};
		font-size: 15px;
		direction: ${p => p.theme.direction};
		accent-color: ${p =>p.theme.colors.primary};
	}

	p, h1, h2, h3{
		margin:0;
	}


	#vimeo-player {
	}
	
	hr {
		border-color: ${p => p.theme.colors.neutralLighter};
		color: ${p => p.theme.colors.neutralLighter};
		margin-top: 0;
	}

	h1 {
		@media (max-width: ${p => p.theme.responsive.media.sm}){
			font-size: 1.5em;
		}
	}

	h2 {
		font-size: 2em;
		font-weight: 700;
		color: ${ p => p.theme.colors.primary};

		@media (max-width: ${p => p.theme.responsive.media.sm}){
			font-size: 1.5em;
		}
	}

	h3 {
		margin-bottom: 10px;
		& > b {
			font-weight: 700;
			color: ${p => p.theme.colors.primary}
		}
	}

	p {
		font-size: 1em;
	}

	button {
		font-family: 'Poppins', sans-serif;
		font-weight: 700;
		font-size: 1em;
		padding-block: 0.4em;
		line-height:22px;
	}

	body {

		margin:0;
		padding:0;
		height: 100%;
        overflow: hidden;
	}

	* {
		box-sizing: border-box;
        user-select: none;
		-webkit-user-select: none;
	}

	#root {
		height: 100%;
	}

	.markdown {
		white-space: pre-wrap;
	}
	.markdown > ol {
		white-space: normal;
		margin: 0;
	}

	/* custom scroll bar */

	/* width */
	
	::-webkit-scrollbar {
		width: 7.5px;
	}

	/* Track */

	::-webkit-scrollbar-track {
		background: ${p => p.theme.colors.neutral};
	}
	
	/* Handle */

	::-webkit-scrollbar-thumb {
		background:  ${p => p.theme.colors.neutralLightest}; 
	}

	/* Handle on hover */

	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}

`;

export default GlobalStyle;
